import React = require("react");
import "./FirstLoginPage.scss";
import {RestDataLoader} from "../dashboard/widgets/unilever/RestDataLoader";
import {Display} from "../components/Display";
import {ChangeCredentialsPage} from "./ChangeCredentialsPage";
import {CompleteProfilePage, RequestParam} from "./CompleteProfilePage";
import {VeboxModels} from "../types/veboxModels";
import {VeboxDanfossLayout} from "../components/layout/VeboxDanfossLayout";
import {VeBoxLoginCard} from "../components/card/VeBoxLoginCard";
import {Loader} from "../components/Utils/loader/Loader";
import {
    changeCredentialsRequest,
    completeProfileRequest,
    getCurrentUser,
    loginWithNewCredentials
} from "./AccountController";
import {isMissingValues, isValidUsername} from "./AccountUtils";
import {ChangeCredentialsParams, FirstLoginPageProps} from "./Account.types";
import {veboxDefaultTheme} from "../index";

enum page {
    changeCredentials = "changeCredentials",
    compileProfile = "compileProfile",
    automaticLoginInProgress = "automaticLoginInProgress"
}

enum changeCredentialsErrorType {
    DUPLICATE_USERNAME = "DUPLICATE_USERNAME",
    INVALID_USERNAME = "INVALID_USERNAME",
    INVALID_PASSWORD = "INVALID_PASSWORD",
    HTTP_BAD_REQUEST = "HTTP_BAD_REQUEST"
}

export const FirstLoginPage: React.FC<FirstLoginPageProps> = ({texts, token}) => {
    const [currentUser, setCurrentUser] = React.useState<VeboxModels.User>()
    const [currentPage, setCurrentPage] = React.useState<page>()
    const [changeCredentialsErrorMessage, setChangeCredentialsErrorMessage] = React.useState<string>();
    const [completeProfileErrorMessage, setCompleteProfileErrorMessage] = React.useState<string>();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [userUpdatedSuccessfully, setUserUpdatedSuccessfully] = React.useState<boolean>(false);

    const changeCredentials = (params: ChangeCredentialsParams) => {
        changeCredentialsRequest(params)
            .then(() => {
                RestDataLoader.login(
                    params.username,
                    params.password,
                    () => {
                        setIsLoading(false);
                        setCurrentPage(page.compileProfile)
                        loginWithNewCredentials(params.username, params.password, token)
                        // window.location.href = "/vebox/"
                    },
                    console.error
                );
            })
            .catch((error) => {
                switch (error.errorType) {
                    case changeCredentialsErrorType.DUPLICATE_USERNAME: {
                        setChangeCredentialsErrorMessage(texts.changeCredentialsPageTexts.usernameAlreadyTaken);
                        break;
                    }
                    case changeCredentialsErrorType.INVALID_USERNAME: {
                        setChangeCredentialsErrorMessage(texts.changeCredentialsPageTexts.wrongUsernameFormat);
                        break;
                    }
                    case changeCredentialsErrorType.INVALID_PASSWORD: {
                        setChangeCredentialsErrorMessage(texts.changeCredentialsPageTexts.wrongOldPassword);
                        break;
                    }
                    case changeCredentialsErrorType.HTTP_BAD_REQUEST: {
                        if ((error.message as string).toLowerCase().includes("password"))
                            setChangeCredentialsErrorMessage(texts.changeCredentialsPageTexts.passwordNotSecure);
                        break;
                    }
                    default: {
                        setChangeCredentialsErrorMessage(texts.errorMessage);
                        console.error(error.message)
                        break;
                    }
                }
                setIsLoading(false);
            })
    }

    const updateProfile = (param: RequestParam[]) => {
        completeProfileRequest({list: param})
            .then((user) => {
                setIsLoading(false);
                setUserUpdatedSuccessfully(true)
                setCurrentUser(user)
            })
            .catch((error) => {
                setIsLoading(false);
                setCompleteProfileErrorMessage(texts.errorMessage)
                console.error(error)
            })
    }
    const getUser = () => {
        getCurrentUser().then(setCurrentUser)
    }

    React.useEffect(() => {
        if (currentUser) {
            if (!isValidUsername(currentUser.username)) {
                setCurrentPage(page.changeCredentials)
            } else if (isMissingValues(currentUser)) {
                setCurrentPage(page.compileProfile)
            } else {
                setCurrentPage(page.automaticLoginInProgress)
                window.location.href = "/vebox/"
            }
        }
    }, [currentUser])

    React.useEffect(() => {
        getUser()
    }, [])

    return (<>
        <VeboxDanfossLayout>
            <div className={"first-login-card-layout"}>
                <Display isVisible={currentPage === page.changeCredentials}>
                    <ChangeCredentialsPage
                        texts={texts.changeCredentialsPageTexts}
                        changeCredentials={changeCredentials}
                        currentUser={currentUser}
                        changeCredentialsErrorMessage={changeCredentialsErrorMessage}
                        setChangeCredentialsErrorMessage={setChangeCredentialsErrorMessage}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                    />
                </Display>
                <Display isVisible={currentPage === page.compileProfile}>
                    <CompleteProfilePage
                        texts={texts.completeProfilePageTexts}
                        updateProfile={updateProfile}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        userUpdatedSuccessfully={userUpdatedSuccessfully}
                        errorMessage={completeProfileErrorMessage}
                        currentUser={currentUser}
                    />
                </Display>
                <Display isVisible={currentPage === page.automaticLoginInProgress}>
                    <VeBoxLoginCard className={"first-login-card"}>
                        <VeBoxLoginCard.Header
                            className={"first-login-card-header"}
                        >
                            <VeBoxLoginCard.Title text={texts.completeProfilePageTexts.userUpdatedSuccessfully}/>
                        </VeBoxLoginCard.Header>
                        <VeBoxLoginCard.Body className={"first-login-card-body"}>
                            <p className={"first-login-intro-text"}>{texts.automaticLoginInProgress}</p>
                            <div className={"loader-section"}>
                                <Loader color={veboxDefaultTheme.palette.brand.main}/>
                            </div>
                        </VeBoxLoginCard.Body>
                    </VeBoxLoginCard>
                </Display>
            </div>
        </VeboxDanfossLayout>
    </>);
}
